import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';

@Injectable()

export class Globales{
   componente: number = 0;
   estadoValido: boolean = true;
   estadoSuspendido: boolean = false;
   selected = new FormControl(0);
   NotaCredito: boolean;
   NotaDebito: boolean;
   DetalleFactura: boolean;
   BuscarFactura: boolean;
   isShowing: boolean;
   accion: number;
}
